import styled from 'styled-components';
import { device } from '../media_queries';


const Nav = styled.div`
  width: 100vw;
  background-color: #262237;
  border-bottom: 1px solid rgba(0, 0, 0, 0.0975);
  position: fixed;
  top: 0;
  z-index: 1;
`;
const NavHeader = styled.div`
  max-width: 1010px;
  width: 80%;
  /* max-width: 1010px;
   */
  
  display: flex;
  align-items: center;
  margin: 0 auto;
`;
const NavLeft = styled.div`
  width: 33.333%;
  text-align: left;
`;
const NavCenter = styled.div`
  width: 33.333%;
  text-align: left;
`;
const Input = styled.input`
  font-size: 16px;
  border: solid 1px #dbdbdb;
  border-radius: 3px;
  color: #262626;
  border-radius: 3px;
  color: #999;
  cursor: text;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  background: #fafafa;
  &:active,
  &:focus {
    text-align: left;
  }
`;
const NavRight = styled.div`
  width: 33.333%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  svg {
    margin-right: 20px;
  }
`;
const MenuLink = styled.a``;

const UserLink = styled.p`
  color: white;
  font-size: 1em;
  margin: 1em .3em;
  padding: 0.25em 1em;
  /* border: 2px solid white; */
  /* border-radius: 3px; */
`;

const AuthButton = styled.button`
  background: ${props => props.auth ? "#262237" : "red"};
  color: ${props => props.auth ? "white" : "green"};
  font-size: 1em;
  font-family:'panton-bold';
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid white;
  border-radius: 3px;
  cursor: pointer;
`;

const LogoImage = styled.img`
  @media ${device.mobileS} {
    width:15vw;
    height:auto;

  }
  @media ${device.tablet} {
    width:10vw;
    height:auto;
  }
  @media ${device.laptop} {
    width: 180px;
    height:60px;
    margin: 4% 0;
  }
  @media ${device.desktop} {
    
  }
`;

export { Nav, NavHeader, NavLeft, NavCenter, NavRight, UserLink, MenuLink, Input, AuthButton, LogoImage }